module.exports = __webpack_public_path__ + "4021976a17d3595324a861f060fe4765.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/li1-21.png
// module id = 601
// module chunks = 0